import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=5fd286c2&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd286c2",
  null
  
)

export default component.exports